import CardsTable from './CardsTable';

export default CardsTable;
